import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {RecordPO} from "@/model/content";
import {WriteRecordForm} from "@/widget/RecordForm/RecordForm";

export enum RecordEnum {
    GetRecordPage = "/record/getRecordPage",
    GetRecord = "/record/getRecord",
    CreateRecord = "/record/createRecord",
    UpdateRecord = "/record/updateRecord",

}

export interface RecordPageVO extends ReviewStatusVO, RecordPO {
}

export interface RecordPageBO extends PaginationBO {
    targetId?: number
}

export interface RecordVO extends RecordPO {
    customerName: string
    creator: string
}

export interface RecordPageVO extends RecordPO {
    avatar: string;
    creator: string;
    customerName: string
}

export const useQueryRecordPage = () => useMutation({
    mutationFn: (data: RecordPageBO) => http.post<BaseVO<PaginationVO<RecordPageVO>>>({
        url: RecordEnum.GetRecordPage,
        data: data,
    }),
})

export const useCreateRecord = () => useMutation({
    mutationFn: (data: WriteRecordForm) => http.put<BaseVO<null>>({url: RecordEnum.CreateRecord, data}),
})

export const useUpdateRecord = () => useMutation({
    mutationFn: (data: WriteRecordForm) => http.post<BaseVO<null>>({url: RecordEnum.UpdateRecord, data}),
})

export const useQueryRecord = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<RecordVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<RecordVO>>({
        url: RecordEnum.GetRecord,
        params: params
    }),
    enabled
})


